var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"UserCenterCollectTab switch-box"},[_c('div',{staticClass:"switch-item switch-item-bar",style:({ 'left': _vm.switchItemLeft + 'px' })}),_vm._v(" "),_vm._l((_vm.switchVipType),function(vo,idx){return _c('div',{key:vo.label + 'switchVipType',staticClass:"switch-item",class:[
        { 'on': idx == _vm.vipType},
        vo.iconClass
      ],on:{"click":function($event){return _vm.toggleVipType(vo,idx)}}},[_c('i',{staticClass:"icon"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(vo.label))])])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }